(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1171],{

/***/ 4942:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-examples/single/[id]",
      function () {
        return __webpack_require__(8757);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ChatSinglePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8109);
/* harmony import */ var _comps_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1083);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9612);
/* harmony import */ var _comps_meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(624);
/* harmony import */ var _comps_player__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1993);
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2706);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7294);
/* harmony import */ var react_responsive_masonry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2337);
/* harmony import */ var sections_gallery_ad_examples__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8106);
/* harmony import */ var sections_gallery_ad_examples_popup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6685);
/* harmony import */ var video_provider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1501);















function getJsonLdData(entity) {
    var ref, ref1;
    if (!entity.preview_video_url) {
        return undefined;
    }
    var ref2, ref3;
    return [
        {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: entity.title,
            description: entity.description,
            thumbnailUrl: [
                entity.preview_thumbnail_url
            ],
            license: "https://zoomerang.app/privacy-policy",
            acquireLicensePage: "https://zoomerang.app/ad-examples/single/" + entity.id,
            copyrightNotice: "Zoomerang",
            uploadDate: entity.created_at,
            author: {
                "@type": "Person",
                name: (ref2 = (ref = entity.owner) === null || ref === void 0 ? void 0 : ref.username) !== null && ref2 !== void 0 ? ref2 : "Zoomerang"
            },
            creator: {
                "@type": "Person",
                name: (ref3 = (ref1 = entity.owner) === null || ref1 === void 0 ? void 0 : ref1.username) !== null && ref3 !== void 0 ? ref3 : "Zoomerang"
            },
            contentUrl: entity.preview_video_url
        }, 
    ];
}
var __N_SSP = true;
function ChatSinglePage(props) {
    var ref;
    var job = props.job, related = props.related;
    var preview_thumbnail_url = job.preview_thumbnail_url, aspect = job.aspect, description = job.description, preview_video_url = job.preview_video_url, share_url = job.share_url, created_at = job.created_at, title = job.title, id = job.id, owner = job.owner;
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_9__.useRef)(null);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), downloadApi = ref1[0], setDownloadApi = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), clicked = ref2[0], setClicked = ref2[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        if (window.history.length <= 1 && clicked) {
            router.push("/ad-examples");
        } else if (clicked) {
            router.back();
        }
    }, [
        clicked,
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        if (downloadApi) return;
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isIOS || isSafari) {
            setDownloadApi(true);
            return;
        }
    }, [
        downloadApi
    ]);
    var thumbnail = preview_thumbnail_url.startsWith("https://") ? preview_thumbnail_url : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tablet:min-h-screen",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_meta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: (title !== null && title !== void 0 ? title : "") + " Advertising Example - Zoomerang",
                description: description,
                cover: thumbnail,
                jsonLdData: getJsonLdData(job)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden desktop:block",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-[100svh] w-screen tablet:h-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative flex w-full flex-col bg-color-popup-cell desktop:mx-auto desktop:w-[1100px] desktop:bg-[transparent] desktop:pt-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                setClicked(true);
                            },
                            className: "hidden items-center desktop:flex",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                    source: "/general/arrow",
                                    format: "svg",
                                    alt: "close icon",
                                    className: "h-[24px] w-[24px] rotate-180"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[18px] font-500 text-blue-700",
                                    children: t("lbl_back")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                setClicked(true);
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("absolute left-4 top-4 z-20 h-10 w-10 rounded-full bg-color-white/20 tablet:h-10 tablet:w-10", "flex items-center justify-center desktop:hidden"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative h-4 w-4 rotate-45",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute left-1/2 top-0 h-4 w-[2px] -translate-x-[1px] rounded-sm bg-color-white"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute left-0 top-1/2 h-[2px] w-4 -translate-y-[1px] rounded-sm bg-color-white"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex w-full flex-col desktop:mt-7 desktop:flex-row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative flex flex-1 items-center justify-center desktop:items-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("absolute inset-0 h-full w-full bg-color-black filter", "pointer-events-none hidden select-none overflow-hidden tablet:block desktop:hidden"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: thumbnail,
                                                alt: "preview image",
                                                className: "h-full w-full scale-110 object-cover opacity-30 blur-lg"
                                            })
                                        }),
                                        preview_video_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            style: {
                                                aspectRatio: aspect
                                            },
                                            className: "relative z-10 w-full tablet:max-h-[600px] tablet:w-auto tablet:max-w-[500px] desktop:max-h-[600px] desktop:max-w-[525px] desktop:rounded-[10px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                                    style: {
                                                        aspectRatio: aspect
                                                    },
                                                    src: preview_video_url,
                                                    poster: thumbnail,
                                                    ref: videoRef,
                                                    playsInline: true,
                                                    className: "relative z-10 w-full tablet:max-h-[600px] tablet:w-auto tablet:max-w-[500px] desktop:max-h-[600px] desktop:max-w-[525px] desktop:rounded-[10px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(video_provider__WEBPACK_IMPORTED_MODULE_13__/* .VideoProvider */ .G, {
                                                    remember: [],
                                                    element: videoRef,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute bottom-0 left-0 z-50 w-full text-color-white",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_5__/* .Timeline */ .TY, {
                                                                radius: "0px 0px 10px 10px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_5__/* .PlayWithProvider */ .uX, {})
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex w-full tablet:h-[646px] tablet:w-[389px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                                source: "/general/empty-media",
                                                alt: "No Video"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex w-full flex-col items-center bg-color-popup-cell tablet:p-0 desktop:w-[472px] desktop:bg-[transparent]", related.related.length === 0 && related.searches.length === 0 && "pb-[90px]"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "no-scrollbar w-full bg-color-popup-cell pt-4 tablet:w-[520px] tablet:py-4 desktop:h-fit desktop:w-full desktop:rounded-[10px]",
                                            children: [
                                                owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_ad_examples_popup__WEBPACK_IMPORTED_MODULE_12__/* .UsernameFollowSection */ .qC, {
                                                    uid: owner.uid,
                                                    username: owner.username,
                                                    follow_status: owner.follow_status,
                                                    profile_pic: (ref = owner.profile_pic) === null || ref === void 0 ? void 0 : ref.original,
                                                    followers: owner.followers
                                                }),
                                                owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mx-4 mt-3 h-[1px] flex-1 shrink-0 bg-color-separator"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_ad_examples_popup__WEBPACK_IMPORTED_MODULE_12__/* .SessionName */ .Im, {
                                                    title: title,
                                                    created_at: created_at,
                                                    hasOwner: owner ? true : false
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "desktop:hidden",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_ad_examples_popup__WEBPACK_IMPORTED_MODULE_12__/* .ShareSection */ .CT, {
                                                        share_url: share_url !== null && share_url !== void 0 ? share_url : "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_6__/* .APP_HOST */ .b, "/ad-examples/single/").concat(id),
                                                        videoUrl: preview_video_url,
                                                        previewImage: thumbnail !== null && thumbnail !== void 0 ? thumbnail : "",
                                                        id: id,
                                                        title: title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mx-4 mt-3 h-[1px] flex-1 shrink-0 bg-color-separator"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_ad_examples_popup__WEBPACK_IMPORTED_MODULE_12__/* .ScriptSection */ .Df, {
                                                    script: props.job.script,
                                                    description: props.job.description
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_ad_examples_popup__WEBPACK_IMPORTED_MODULE_12__/* .TryNowButton */ .Oz, {
                                                    description: description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "hidden w-full bg-color-popup-cell desktop:mt-5 desktop:block desktop:h-fit desktop:rounded-[10px] desktop:pb-4",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_ad_examples_popup__WEBPACK_IMPORTED_MODULE_12__/* .ShareSection */ .CT, {
                                                share_url: share_url !== null && share_url !== void 0 ? share_url : "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_6__/* .APP_HOST */ .b, "/ad-examples/single/").concat(id),
                                                videoUrl: preview_video_url,
                                                previewImage: preview_thumbnail_url,
                                                id: id,
                                                title: title
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedSectionSinglePage, {
                            related: related
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden tablet:block desktop:mt-[70px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_footer__WEBPACK_IMPORTED_MODULE_1__/* .WrappedFooter */ .M, {})
            })
        ]
    });
}
function RelatedSectionSinglePage(props) {
    var _related = props.related, searches = _related.searches, related = _related.related;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            searches.length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex w-full flex-col gap-3 px-4 pt-5 desktop:w-[1175px] desktop:px-0 desktop:pt-12", related.length === 0 && "pb-[90px]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[22px] font-500 tracking-normal text-blue-700",
                        children: t("txt_related_keywords")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "no-scrollbar flex h-[36px] w-full shrink-0 flex-row gap-[10px] overflow-x-scroll",
                        children: searches.map(function(keyword) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/ad-examples/".concat(encodeURIComponent(keyword)),
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex h-full shrink-0 flex-row items-center justify-center gap-[6px] rounded-[6px]", "bg-color-background p-3 tablet:bg-color-background desktop:bg-color-popup-cell", "text-[13px] font-400 tracking-wider text-blue-700 [--icon-color:var(--color-blue-600)]"),
                                children: keyword
                            }, keyword);
                        })
                    })
                ]
            }),
            related.length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-col gap-[14px] px-4 pb-[90px] pt-5 desktop:w-[1175px] desktop:px-0 desktop:pb-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[20px] font-500 tracking-normal text-blue-700",
                        children: t("txt_relevant_ads")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_10__/* .ResponsiveMasonry */ .G, {
                        columnsCountBreakPoints: {
                            1: 3,
                            760: 4,
                            1280: 5
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            gutter: "10px",
                            children: related.map(function(single) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_ad_examples__WEBPACK_IMPORTED_MODULE_11__/* .SingleAd */ .$f, {
                                    entity: single
                                }, single.id);
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(4942); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);